import {Component, inject, input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonButton, IonCard, IonCardContent, IonContent, IonRow, IonText, PopoverController} from '@ionic/angular/standalone';
import {Badge, Profile} from '@models';
import {ProfileService} from '@services';

@Component({
	           selector: 'app-message-popin',
	           standalone: true,
	           templateUrl: './badge-modale.component.html',
	           imports: [
		           IonContent,
		           IonCard,
		           IonCardContent,
		           IonRow,
		           IonText,
		           FormsModule,
		           IonButton
	           ],
	           styleUrls: ['./badge-modale.component.scss']

           })
export class BadgeModaleComponent {

	badges = input<Badge[]>([]);
	profile = input.required<Profile>();
	private profileService = inject(ProfileService);
	private popover = inject(PopoverController);

	constructor() {
	}

	closePopover() {
		return this.popover.dismiss();
	}

	updateBadges() {
		this.profile().badges = this.badges().filter(b => b.used).map(b => b.uuid);
		this.profileService.update(this.profile()).then(() => this.closePopover());
	}
}
